module.exports = __webpack_public_path__ + "img/appAsset-brand--Discover.ac52cd46.svg";